class AnimationComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { AnimationComponentData };
